// extracted by mini-css-extract-plugin
export default {"plainButton":"PlainButton_plainButton__zAIVg"};